export const RentalStatus = Object.freeze({
  Sale: 'Venta',
  Rent: 'Alquiler',
});
